import React from 'react'
import DatePicker from 'react-datepicker'

import API from 'service/api'
import Util, { Data } from 'service/util'

import PopMessage from 'component/pop-msg/PopMessage'

const today = Util.getToday()

const AnnouncePriceModel = (props) =>
{
  const [isLoading, setIsLoading] = React.useState(false);
  const [from, setFromDate] = React.useState(today);
  const [to, setToDate] = React.useState(today);

  const sendAnnouncement = () =>
  {
    let dto = {
      from_dtm: Util.ShortDate(from),
      to_dtm:   Util.ShortDate(to)
    }

    setIsLoading(true);
    API.sendPriceChangeMessage(dto).then(resp =>
    {
      if (!resp.success)
      {
        PopMessage.show('價格變動通告發送失敗。', '錯誤', 'danger')
        return false;
      }

      PopMessage.show('已發送價格變動通告。', '發送成功', 'success')
      props.closeModal()
    })

    setTimeout(() => setIsLoading(false), 5000);
  }

  return (
    <div className="announce-price-modal">
      <label className="field">
        <strong>起始日期</strong>
        <DatePicker selected={from} onChange={setFromDate}
          dateFormat="yyyy-MM-dd" />  
      </label>
      <label className="field">
        <strong>結束日期</strong>
        <DatePicker selected={to} onChange={setToDate}
          dateFormat="yyyy-MM-dd" />
      </label>
      <div className="button-group">
        <button className="btn red" onClick={sendAnnouncement} disabled={isLoading}>發送</button>
      </div>
    </div>
  )
}

export default AnnouncePriceModel;
